var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRighttowork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#128abc;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M158.15,141.58v20.49a6.51,6.51,0,0,1-6.51,6.5H104.37a6.51,6.51,0,0,1-6.51-6.5V141.58a6.51,6.51,0,0,1,6.51-6.51h47.27A6.51,6.51,0,0,1,158.15,141.58Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M232,60.78H24a3.5,3.5,0,0,0-3.51,3.5v81.54a3.51,3.51,0,0,0,3.51,3.5H92.86v-7.74a11.51,11.51,0,0,1,11.51-11.51h47.27a11.51,11.51,0,0,1,11.51,11.51v7.74H232a3.51,3.51,0,0,0,3.49-3.5V64.28A3.5,3.5,0,0,0,232,60.78ZM51.37,77H41.86a3.5,3.5,0,0,0-3.51,3.5v22.19a2.5,2.5,0,0,1-5,0V80.47A8.51,8.51,0,0,1,41.86,72h9.51a2.5,2.5,0,1,1,0,5ZM151.68,95.43H104.33a2.5,2.5,0,1,1,0-5h47.35a2.5,2.5,0,0,1,0,5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M228.75,154.32V233.8H27.26V154.32h65.6v7.75a11.52,11.52,0,0,0,11.51,11.5h47.27a11.52,11.52,0,0,0,11.51-11.5v-7.75Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M171.66,34.7V55.78H84.35V34.7A12.52,12.52,0,0,1,96.86,22.2h62.29A12.51,12.51,0,0,1,171.66,34.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRighttowork);
export default __webpack_public_path__ + "static/media/righttowork.8f4bf980cd5f773654c17f1cf9292162.svg";
export { ForwardRef as ReactComponent };